import { render, staticRenderFns } from "./BoardSpace.vue?vue&type=template&id=3dd61957&"
import script from "./BoardSpace.vue?vue&type=script&lang=ts&"
export * from "./BoardSpace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports